import { TableCell, TableHead, TableRow } from "@mui/material"
import classNames from "classnames"
import { getColumnWidth } from "./utils"
import { Icon, IconColor } from "@/components/shared/Icon"
import { Column, SortDirection } from "@/components/shared/Table/types"

export interface HeaderProps<T> {
   columns: Column<T>[]
   onSort?: (field: keyof T) => void
   sortField?: keyof T | null
   sortDirection?: SortDirection | null
   editable?: boolean
}

export function Header<T>({
   columns,
   onSort,
   editable = true,
}: HeaderProps<T>) {
   const handleSortClick = (field: keyof T) => {
      if (onSort) {
         onSort(field)
      }
   }

   return (
      <TableHead>
         <TableRow className="table__header-row">
            {columns.map((column) => (
               <TableCell
                  id={`header-${column.key as unknown}`}
                  key={String(column.key)}
                  className={classNames("table__header-cell", {
                     "table__header-cell--sortable": column.sortable,
                  })}
                  {...(column.width && {
                     style: { width: getColumnWidth(column) },
                  })}
                  onClick={() => column.sortable && handleSortClick(column.key)}
               >
                  <span className="table__header-content">
                     {column.icon ? (
                        <Icon
                           name={column.icon}
                           color={IconColor.HONOLULU_BLUE}
                           size="16"
                        />
                     ) : (
                        <span className="table__header-label">
                           {column.label}
                        </span>
                     )}
                     {column.sortable && (
                        <Icon
                           name="sortBy"
                           size="13"
                           color={IconColor.HONOLULU_BLUE}
                        />
                     )}
                  </span>
               </TableCell>
            ))}
            {editable && (
               <TableCell
                  className={classNames(
                     "table__header-cell",
                     "table__header-cell--actions"
                  )}
               />
            )}
         </TableRow>
      </TableHead>
   )
}
